<template>
  <transition name="fade" :duration="{ enter: 0, leave: 500 }">
    <gd-footer
      :show="footerRef"
      class="gd-footer"
      :user-country="userCountry"
      :payout-user="payout"
      :blank="footerBlankRef"
      :locales="storeGd.supportedLocales"
      @flag="languageSelect"
      @link="footerLink"
    ></gd-footer>
  </transition>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { GD, Storage, STORE_NAME, User } from '@gd/storage'
import { GdFooter } from '@gd/classic-template'
import events from '@gd/event-bus'

const props = withDefaults(defineProps<{ footer: boolean; footerBlank: boolean }>(), { footer: true })
const footerRef = ref(props.footer)
const footerBlankRef = ref(props.footerBlank)
const storeGd: GD = new Storage().read(STORE_NAME.GD)
const storeUser: User = new Storage().read(STORE_NAME.USER)
const payout = storeUser.payout || true
const userCountry = storeUser.locale ? storeUser.locale.split('-')[1] : ''

onMounted(() => {
  events.$on('template', (obj: { header: boolean; headerBlank: boolean; footer: boolean; footerBlank: boolean }) => {
    if (Object.prototype.hasOwnProperty.call(obj, 'footer')) {
      footerRef.value = obj.footer
    }
    if (Object.prototype.hasOwnProperty.call(obj, 'footerBlank')) {
      footerBlankRef.value = obj.footerBlank
    }
  })
})

function footerLink(name: string) {
  let url
  switch (name) {
    case 'home':
      url = '/gd/homepage/home.xhtml'
      break
    case 'impressum':
      url = '/gd/help/help.xhtml?page=help.impressum'
      break
    case 'contact':
      url = '/gd/support/contact.xhtml'
      break
    case 'about':
      url = 'https://inside.gameduell.com/#about'
      ;(window as any).open(url, '_blank', 'noopener')
      return
    case 'sitemap':
      url = '/gd/sitemap/index.xhtml'
      break
    case 'agb':
      url = '/gd/help/agb.xhtml'
      break
    case 'withdrawal':
      url = '/gd/help/withdrawal.xhtml'
      break
    case 'privacy':
      url = '/gd/help/privacy.xhtml'
      break
    case 'partner':
      url = '/gd/help/help.xhtml?page=help.partner'
      break
    case 'jobs':
      url = 'https://inside.gameduell.com/#jobs'
      ;(window as any).open(url, '_blank', 'noopener')
      return
    case 'mobile':
      url = '/gd/mobile/uiswitch/?desktop=false'
      break
    case 'accessibility':
      url = '/gd/help/accessibility.xhtml'
      break
  }
  location.href = url || '#'
}
function languageSelect(lang: string) {
  let l = ''
  // map languages to classic footer
  switch (lang) {
    case 'en':
      l = 'en_US'
      break
    case 'en-GB':
      l = 'en_GB'
      break
    case 'es':
      l = 'es_ES'
      break
    case 'es-US':
      l = 'es_US'
      break
    case 'fr':
      l = 'fr_FR'
      break
    case 'nl':
      l = 'nl_NL'
      break
    case 'sv':
      l = 'sv_SE'
      break
    case 'da':
      l = 'da_DK'
      break
    case 'de':
      l = 'de_DE'
      break
    case 'de-AT':
      l = 'de_AT'
      break
  }
  location.href = '/gd/switchLanguage?lang=' + l
}
</script>

<style lang="less">
@import '~@npm/@gd/classic-template/lib/footer';

#gdfooter {
  .footer();
}
#sectionFooterNavigation {
  .sectionFooterNavigation();
  #bottomnav {
    border-bottom: 1px solid @c0-d;
  }
}
#locales {
  .flags();
}
.gd-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}
// overwrite styles which comes from the base_loggedout.agg.css and distroy the new CSS
</style>
